import React, { Suspense } from 'react';
const RailDetails = React.lazy(() => import('@stone/components/listing/RailDetails'));
const ProgressiveReveal = React.lazy(() => import('@stone/components/progressiveReveal/ProgressiveReveal'));
const editorialsMap = {
    // parallax
    component_details: RailDetails,
    component_progressive_reveal: ProgressiveReveal,
};
const ProductEditorialRail = (props) => {
    return React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) }, (editorialsMap[props.typeid] && React.createElement(editorialsMap[props.typeid], props.componentProps)) || React.createElement(React.Fragment, null));
};
export default ProductEditorialRail;
